export { REPLACE_DR_PREFIX_REGEX } from '@bondvet/types/booking/util';

export const TRAVEL_CERTIFICATE_REASON_VALUE = '--TRAVEL-CERTIFICATE--';
